import { useNavigate } from "react-router-dom";
import NewNavbar from "../components/NewNavbar";
import SEO from "../components/SEO";

const EvenessProPage = () => {
  const navigate = useNavigate();

  const handleUnlockPro = () => {
    navigate("/checkout");
  };

  return (
    <>
      <SEO
        title="Eveness Pro | AI Try-On & Personalized Fashion"
        description="Unlock Eveness Pro for unlimited try-ons, AI searches, GPT chats, and personalized fashion recommendations."
        path="/eveness-pro"
      />
      <div className="min-h-screen bg-[#F4F4F4] text-[#2F2F2F]">
        <NewNavbar />
        <main className="mx-auto w-full max-w-[1120px] px-4 pb-16 pt-8">
          <div className="text-center">
            <div className="mb-4 font-spaceMono text-[11px] uppercase tracking-[8%] text-[#5C5C5C]">
              ● EXE_UNLOCK_PRO
            </div>

            <h1 className="font-helvena text-[28px] font-medium tracking-[-2%] text-[#313131] md:text-[36px]">
              Free to start. $4.99 to unlock everything.
            </h1>
          </div>

          <section className="mx-auto mt-14 grid max-w-[940px] grid-cols-1 gap-6 md:grid-cols-2">
            {/* Free card */}
            <div className="rounded-[10px] border border-[#E5E5E5] bg-white p-[28px] h-[450px] md:h-[430px]">
              <div className="flex items-center justify-between">
                <span className="font-spaceMono text-[11px] uppercase tracking-[8%] text-[#5C5C5C]">
                  TIER_FREE
                </span>
                <span className="font-spaceMono text-[11px] uppercase tracking-[8%] text-[#5C5C5C]">
                  MONTHLY_CREDITS
                </span>
              </div>

              <div className="mt-6 font-spaceMono text-[36px] font-medium tracking-[0%] text-[#313131]">
                $0
              </div>

              <p className="mt-4 font-helvena text-[13px] text-[#5C5C5C]">
                Explore the catalog, build your profile, try Eveness end-to-end.
              </p>

              <div className="mt-8 space-y-5">
                {[
                  ["TRY-ONS", "4/10", "40%"],
                  ["AI SEARCHES", "3/10", "30%"],
                  ["GPT CHATS", "5/15", "34%"],
                ].map(([label, value, width]) => (
                  <div key={label}>
                    <div className="mb-2 flex items-center justify-between font-spaceMono text-[11px] uppercase tracking-[6%]">
                      <span className="text-[#5C5C5C]">{label}</span>
                      <span className="text-[#8F333B]">{value}</span>
                    </div>

                    <div className="h-[5px] rounded-full bg-[#E3E3E3]">
                      <div
                        className="h-full rounded-full bg-[#9C3540]"
                        style={{ width }}
                      />
                    </div>
                  </div>
                ))}
              </div>

              <button
                type="button"
                onClick={() => navigate("/marketplace")}
                className="mt-[38px] h-[43px] w-full rounded-[4px] border border-[#313131] bg-white font-spaceMono text-[13px] tracking-[0.08em] text-[#313131] transition hover:bg-[#F5F5F5]"
              >
                Continue Free
              </button>
            </div>

            {/* Pro card */}
            <div className="rounded-[8px] bg-[#303030] p-[28px] text-white h-[430px]">
              <div className="flex items-center justify-between">
                <span className="font-spaceMono text-[11px] uppercase tracking-[8%] text-white">
                  TIER_PRO
                </span>

                <span className="h-[21px] rounded-full bg-[#8F333B] px-2 py-[3px] font-spaceMono text-[9px] uppercase tracking-[0.1em] text-white">
                  RECOMMENDED
                </span>
              </div>

              <div className="mt-[14px] flex items-end gap-2 text-white font-spaceMono">
                <span className="text-[36px] font-normal tracking-[0%]">
                  $4.99
                </span>
                <span className="mb-2 text-[13px] text-[#CFCFCF]">/mo</span>
              </div>

              <p className="mt-[6px] font-helvena text-[13px] text-[#FFFFFFB2]">
                Unlimited Try-Ons, AI Searches and GPT Chats. Priority indexing
                on new drops.
              </p>

              <ul className="mt-[22px] space-y-[10px] font-helvena text-[13px] text-[#FFFFFFD9]">
                {[
                  "Unlimited Virtual Try-Ons",
                  "Unlimited GPT styling chats",
                  "Priority product indexing",
                  "Boards: save unlimited looks",
                  "Early access to seasonal palettes",
                ].map((item) => (
                  <li key={item} className="flex items-center gap-[10px]">
                    <span className="h-1.5 w-1.5 rounded-full bg-[#B8434E]" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <button
                type="button"
                onClick={handleUnlockPro}
                className="mt-[36px] h-[43px] w-full rounded-[4px] bg-[#8F333B] font-spaceMono text-[13px] tracking-[0%] text-white transition hover:bg-[#93323B]"
              >
                Unlock Pro - $4.99/mo
              </button>
            </div>
          </section>
        </main>
      </div>
    </>
  );
};

export default EvenessProPage;
